import { z } from 'zod';
import { objectIdSchema } from './objectId';

export const BrandLevelSchema = z.object({
  _id: objectIdSchema,
  name: z.string().optional(),
});
